<template>
  <master-main
    :route="getModuleRoute"
    :addProperties="{
      eventType: 1,
      routeToCreate: getModuleRoute,
    }"
    :tableProperties="tableProperties"
    :exportProperties="{
      pdf: {
        filename: `${$t('sowing.sowing_methods')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('sowing.sowing_methods')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 160,
      },
    ]"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    @refresh="refresh"
  >
  </master-main>
</template>
<script>
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import SowingMethodTable from './sowing-method-table';

export default {
  components: { MasterMain },
  computed: {
    getModuleRoute() {
      return 'seeding/sowingmethods';
    },
    buildTableProperties() {
      return {
        tableColumns: [...SowingMethodTable().tableColumns],
        effectTags: 'dark',
        model: 'sowingmethod',
        widthOperations: 110,
        widthColumnStatus: 160,
      };
    },
  },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '50%' },
    };
  },
  mixins: [
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinAlert
  ],
};
</script>
